export const LOCALES = {
  en: 'en',
  de: 'de',
  es: 'es',
  fr: 'fr',
  'de-DE': 'de-DE',
  'en-CA': 'en-CA',
  'en-GB': 'en-GB',
  'en-US': 'en-US',
  'en-US-x-am': 'en-US-x-am',
  'en-US-x-bl': 'en-US-x-bl',
  'en-US-x-jm': 'en-US-x-jm',
  'en-US-x-pg': 'en-US-x-pg',
  'fr-CA': 'fr-CA',
  'pl-PL': 'pl-PL',
};
